export default {
  login(state, { user }) {
    if (user.uuid) {
      localStorage.setItem("uuid", user.uuid);
    }

    state.user = user;
  },
  logout(state) {
    state.user = false;
  },
  setGuestPermissions(state, list) {
    state.guestPermissions = list || [];
  },
  devices(state, { devices }) {
    state.user.devices = devices;
  },
  updateSearchText(state, { value, category }) {
    const currentCategory = category || state.route.name;
    state[currentCategory].searchText = value;
  },
  setTheme(state, isDark) {
    state.isDarkTheme = isDark;
    localStorage.setItem("user-theme", isDark ? "dark-theme" : "light-theme");

    if (isDark) {
      document.documentElement.classList.add("dark-theme");
    } else {
      document.documentElement.classList.remove("dark-theme");
    }
  },
};
